<div [dir]="languageDir">
    <router-outlet *ngIf="showContent"></router-outlet>
</div>
<!-- <app-ChatBot></app-ChatBot> -->
  

